import pdfTextEN from "../../locales/english/en-szc-pdf.json";
import pdfTextFR from "../../locales/french/fr-szc-pdf.json";

const getPDFTranslations = (lang = "en") => {
    let pdfText = lang === "en" ? pdfTextEN : pdfTextFR;

    const t = (fullKey, fallbackText = "", variables = {}) => {
        let key = fullKey.replace("SZCpdf.", "");
        if (key in pdfText && pdfText[key] !== "nan"){
            let text = pdfText[key];
            for (let subKey in variables) {
                text = text.replace("{{" + subKey + "}}", variables[subKey]);
            }
            return text;
        }
        else
            return fallbackText !== "" ? fallbackText : key;
    }

    return { t };
}

export default getPDFTranslations;

